export const LOCAL_FILTER_FIELDS = [
    {
        label: "Designation Code",
        type: "text",
        name: "designationCode",
    },
    {
        label: "Designation Name",
        type: "text",
        name: "designationName",
    }
]